export default __webpack_public_path__ + "static/media/shirt15.4138a5d5.jpeg";